import React from 'react'

import { SidebarPage } from './Sidebar'
import SidebarNavSection from './SidebarNavSection'

interface Props {
  items: { title?: string; pages: SidebarPage[] }[]
}

const SidebarNav: React.FC<Props> = ({ items }) => {
  return (
    <ul className="sidebar-nav flex-grow-1">
      {items && (
        <>
          {items.map((item, index) => (
            <SidebarNavSection
              key={index}
              pages={item.pages}
              title={item.title}
            />
          ))}
        </>
      )}
    </ul>
  )
}

export default SidebarNav
